import React from "react";
import { TextField, Button, Alert } from "@mui/material";

interface EmailFormProps {
  email: string;
  onEmailChange: (email: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  error: string | null;
  isLoading: boolean;
  isEmailValid: boolean;
}

const darkTextFieldSx = {
  "& .MuiOutlinedInput-root": {
    color: "white",
    borderRadius: "16px",
    background: "rgba(255,255,255,0.03)",
    "& fieldset": {
      borderColor: "rgba(255,255,255,0.1)",
    },
    "&:hover fieldset": {
      borderColor: "rgba(255,255,255,0.25)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "rgba(255,255,255,0.5)",
    },
  },
  "& .MuiInputLabel-root": {
    color: "rgba(255,255,255,0.5)",
    "&.Mui-focused": { color: "rgba(255,255,255,0.8)" },
  },
};

const darkButtonSx = {
  mt: 3,
  borderRadius: "16px",
  py: 1.5,
  background: "#8a1125",
  textTransform: "none",
  fontSize: "15px",
  fontWeight: 600,
  "&:hover": { background: "#c41830" },
  "&.Mui-disabled": {
    background: "rgba(138,17,37,0.3)",
    color: "rgba(255,255,255,0.3)",
  },
};

const darkAlertSx = {
  mt: 2,
  background: "rgba(244,44,4,0.1)",
  color: "#ff6b4a",
  border: "1px solid rgba(244,44,4,0.2)",
  borderRadius: "12px",
  "& .MuiAlert-icon": { color: "#ff6b4a" },
};

export const EmailForm: React.FC<EmailFormProps> = ({
  email,
  onEmailChange,
  onSubmit,
  error,
  isLoading,
  isEmailValid,
}) => {
  return (
    <form onSubmit={onSubmit}>
      <TextField
        fullWidth
        label="E-post"
        type="email"
        value={email}
        onChange={(e) => onEmailChange(e.target.value)}
        margin="normal"
        required
        disabled={isLoading}
        autoComplete="email"
        sx={darkTextFieldSx}
      />

      {error && (
        <Alert severity="error" sx={darkAlertSx}>
          {error}
        </Alert>
      )}

      <Button
        fullWidth
        type="submit"
        variant="contained"
        size="large"
        disabled={isLoading || !email || !isEmailValid}
        sx={darkButtonSx}
      >
        {isLoading ? "Skickar kod..." : "Skicka kod"}
      </Button>
    </form>
  );
};
